<template>
  <a-breadcrumb style="margin: 16px 0">
    <a-breadcrumb-item>贡献者</a-breadcrumb-item>
    <a-breadcrumb-item>贡献者榜单</a-breadcrumb-item>
  </a-breadcrumb>
  <a-radio-group v-model:value="sigOrRepository" style="margin-bottom: 16px;">
    <a-radio-button value="sig">代码贡献 TOP100</a-radio-button>
    <a-radio-button value="repository" disabled>深耕开发者榜单</a-radio-button>
  </a-radio-group>
  <div v-if="sigOrRepository === 'sig'" class="title-container">
    <contributor-leaderboard-top style="width: 100%;" />
  </div>
  <div v-else class="title-container">
    <span class="title">深耕开发者榜单</span>
    <a-tag color="blue" style="margin-left: 8px;">非华为</a-tag>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import ContributorLeaderboardTop from './ContributorLeaderboardTop.vue';
const sigOrRepository = ref('sig');
</script>

<style scoped>
.title-container {
  padding: 16px;
}

.title {
  text-align: left;
  font-size: 20px;
  font-weight: 600;
}
</style>